import React, { useState, useEffect, useContext } from "react";
import errorRedIcon from "../../images/errorRedIcon.png";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function BlackListedExpertRow({
  expert,
}) {
  const { API_URL } = useContext(UrlContext);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleted, setDeleted] = useState(false);

  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);


  const [expertData, setExpertData] = useState({
    Name: "",
    link: "",
    email: "",
  });

  useEffect(() => {
    console.log(expert)
    setExpertData({
      Name: expert.Name,
      link: expert.link,
      email: expert.email,
    });
  }, [expert]);

  const deleteBlackListedExpertHandler = () => {
    const blackListedExpertID = expert.id;
    const url = `${API_URL}delete-blacklistexpert`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        blackListedExpertID: blackListedExpertID,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setDeletePopup(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "Expert deleted from blacklist successfully!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setDeleted(true);
        } else {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  return (
    <>
        <tr key={expert.id}>
              <td>
                <a
                      className="prjdetails-con-name"
                      href={expertData.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {expertData.Name}
                </a>
                
              </td>
              <td>{expertData.email}</td>
              <td>
                  <i
                      className="fa-solid fa-trash-can"
                      onClick={() => setDeletePopup(true)}
                  ></i>
              </td>
        </tr>

      {deletePopup && (
        <div className="deleteUser-popup-wrapper">
          <div className="tab-pane fade show deleteUser-div">
            <div>
              <center>
                <img
                  src={errorRedIcon}
                  width="50px"
                  height="50px"
                  alt="alert-icon"
                />
                <p>
                  <strong>WARNING!</strong> Expert will be removed from the blacklist!
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setDeletePopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: 6 }}
                  onClick={deleteBlackListedExpertHandler}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
